export enum PostsTypes {
	POSTS_GET_REQUEST = "POSTS_GET_REQUEST",
	POSTS_GET_REQUEST_SUCCESS = "POSTS_GET_REQUEST_SUCCESS",
	POSTS_GET_REQUEST_UPDATE = "POSTS_GET_REQUEST_UPDATE",
	POSTS_GET_REQUEST_ERROR = "POSTS_GET_REQUEST_ERROR",

	POSTS_GET_REQUEST_STATE_RESET = "POSTS_GET_REQUEST_STATE_RESET"
}
